import { render } from "./gallery-content-list.vue?vue&type=template&id=d87faa0c&scoped=true"
import script from "./gallery-content-list.vue?vue&type=script&lang=js"
export * from "./gallery-content-list.vue?vue&type=script&lang=js"

import "./gallery-content-list.vue?vue&type=style&index=0&id=d87faa0c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87faa0c"]])

export default __exports__